import { MenuItem } from "primeng/api";

const BREADCRUMB_DATA_DIMENSIONS: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Dimensions', routerLink: '/configuration/dimensions', queryParamsHandling: 'preserve' },
];
const BREADCRUMB_DATA_APPLICATIONS: MenuItem[] = [
  { label: 'Home' },
];
const KNOWLEDGEHUB_BREADCRUMB: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
];
const BREADCRUMB_DATA_KNOWLEDGEBASE: MenuItem[] = [
  ...KNOWLEDGEHUB_BREADCRUMB,
  { label: 'Knowledge Base', routerLink: '/configuration/knowledgebase/home', queryParamsHandling: 'preserve' }
];
const BREADCRUMB_DATA_PRODUCT: MenuItem[] = [
  ...KNOWLEDGEHUB_BREADCRUMB,
  { label: 'Products' }
];
const BREADCRUMB_DATA_SME: MenuItem[] = [
  ...KNOWLEDGEHUB_BREADCRUMB,
  { label: 'SME Dashboard', routerLink: '/configuration/knowledgebase/sme-dashboard', queryParamsHandling: 'preserve' },
];
const BREADCRUMB_DATA_CHAT: MenuItem[] = [
  ...KNOWLEDGEHUB_BREADCRUMB,
  { label: 'SME Chat' }
];
const BREADCRUMB_DATA_EMAIL: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Email', routerLink: '/configuration/channels/email' },
];
const BREADCRUMB_DATA_CHATS: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Chat', routerLink: '/configuration/channels/chat' },
];
const BREADCRUMB_DATA_PROMPTS: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app', queryParamsHandling: 'preserve' },
  { label: 'Prompts',routerLink: '/configuration/wiseflow/prompts' }
];
const BREADCRUMB_DATA_LLM: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'LLM Configuration', routerLink: '/configuration/llm' }
];
const BREADCRUMB_DATA_TOOLS: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Tools' },
];

const BREADCRUMB_DATA_EVENTS: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Events' },
];

const BREADCRUMB_DATA_EDIT_EVENTS: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Events', routerLink: '/configuration/wiseflow/events', queryParamsHandling: 'preserve' },
  { label: 'Edit Events' }
]

const BREADCRUMB_DATA_AddTOOLS: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Tools' ,routerLink: '/configuration/wiseflow/tools', queryParamsHandling: 'preserve'},
  { label: 'Add or Edit Tools'}
];

const BREADCRUMB_DATA_API: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Tools' ,routerLink: '/configuration/wiseflow/tools', queryParamsHandling: 'preserve'},
  { label: 'Add or Edit Tools', routerLink: '/configuration/wiseflow/tools/add-tool', queryParamsHandling: 'preserve'},
  { label: 'Add or Edit Api Tool'}
];

const BREADCRUMB_DATA_AUTHENTICATION_API: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Tools' ,routerLink: '/configuration/wiseflow/tools', queryParamsHandling: 'preserve'},
  { label: 'Add or Edit Tools', routerLink: '/configuration/wiseflow/tools/add-tool', queryParamsHandling: 'preserve'},
  { label: 'Add or Edit Authentication Api Tool'}
];

const BREADCRUMB_DATA_AGENTS: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Agents' },
];
const BREADCRUMB_DATA_ORGANIZATIONS: MenuItem[] = [
  { label: 'Organizations' },
];
const BREADCRUMB_DATA_ROLES: MenuItem[] = [
  { label: 'Roles', routerLink: '/usermgmt/roles' },
];
const BREADCRUMB_DATA_USERS: MenuItem[] = [
  { label: 'Users', routerLink: '/usermgmt/users' },
];
const BREADCRUMB_DATA_ASSIGNRESOURCE: MenuItem[] = [
  { label: 'Applications', routerLink: '/usermgmt/applications' },
  { label: 'Resources', routerLink: '/assignResource' }
];
const BREADCRUMB_DATA_APPLICATION: MenuItem[] = [
  { label: 'Applications' },
];
const BREADCRUMB_DATA_WISEFLOW: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Wise Flow', routerLink: '/configuration/wiseflow', queryParamsHandling: 'preserve' },
];
const BREADCRUMB_DATA_HOME: MenuItem[] = [
  { label: 'Home' }
];
const BREADCRUMB_DATA_DASHBOARDEMAIL: MenuItem[] = [
  { label: 'Home', routerLink: '/ticket-dashboard' },
  { label: 'Email', routerLink: '/ticket-dashboard/email/email-ticket' },
];
const BREADCRUMB_DATA_DASHBOARDCHAT: MenuItem[] = [
  { label: 'Home', routerLink: '/ticket-dashboard' },
  { label: 'Chat', routerLink: '/ticket-dashboard/chat' },
];
const BREADCRUMB_DATA_SETTINGS: MenuItem[] = [
  { label: 'User Settings', routerLink: '/settings' }
]
const BREADCRUMB_DATA_CUSTOMERTIER: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Dimensions', routerLink: '/configuration/dimensions' },
  { label: 'CUSTOMER_TIER', routerLink: '/configuration/dimensions/subcategory', queryParamsHandling: 'preserve' },
  { label: 'Customers', routerLink: '/configuration/dimensions/subcategory/details', queryParamsHandling: 'preserve' },
];
const BREADCRUMB_DATA_CUSTOMERS: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Customer list', routerLink: '/home/customers' },
];
const BREADCRUMB_DATA_DIMENSIONS_SUBCATEGORY: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Dimensions', routerLink: '/configuration/dimensions' },
];
const BREADCRUMB_DATA_ALLOWED: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Channels' },
];
const BREADCRUMB_DATA_ORGANIZATION: MenuItem[] = [
  { label: 'Organizations', routerLink: '/usermgmt/customer' },
];
const BREADCRUMB_DATA_CONFIG: MenuItem[] = [
  { label: 'Roles', routerLink: '/usermgmt/roles' },

];
const BREADCRUMB_DATA_USERS_CONFIG: MenuItem[] = [
  { label: 'Users', routerLink: '/usermgmt/users' },

];
const BREADCRUMB_DATA_USERS_PROFILE: MenuItem[] = [
  {
    label: 'Chat', routerLink: '/user-activity' },
  { label: 'User Profile', routerLink: '/user-activity/profile' }
];
const BREADCRUMB_DATA_USERS_INTENT: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Dimensions', routerLink: '/configuration/dimensions' },
];
const BREADCRUMB_DATA_ERRORDETAILS: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Knowledge Base', routerLink: '/configuration/knowledgebase/home'},
  { label: 'Error Correction' }
];
const BREADCRUMB_DATA_TRANSCRIPTIONERROR: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Knowledge Base', routerLink: '/configuration/knowledgebase/home'},
  { label: 'Error Correction', routerLink: '/configuration/knowledgebase/home/errorDetails', queryParamsHandling: 'preserve' }
];
const BREADCRUMB_DATA_ERRORPAGE: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Knowledge Base', routerLink: '/configuration/knowledgebase/home'},
  { label: 'Error Correction', routerLink: '/configuration/knowledgebase/home/errorDetails', queryParamsHandling: 'preserve' }
];
const BREADCRUMB_DATA_DASHBOARD_PHONE: MenuItem[] = [
  { label: 'Electronics' },
  { label: 'Computer' },
  { label: 'Accessories' },
  { label: 'Keyboard' },
  { label: 'Wireless' }
];
const BREADCRUMB_DATA_DASHBOARD_HOME: MenuItem[] = [
  { label: 'Home', routerLink: '/ticket-dashboard', }
];
const BREADCRUMB_DATA_WISEFLOW_TOOLS: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Wise Flow', routerLink: '/configuration/wiseflow', queryParamsHandling: 'preserve' },
  { label: 'Tools and Prompts', routerLink: '/configuration/wiseflow/wiseflow-tools', queryParamsHandling: 'preserve' }
];
const BREADCRUMB_DATA_ADD_INTENT: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Dimensions', routerLink: '/configuration/dimensions' },
  { label: 'INTENT', routerLink: '/configuration/dimensions/subcategory', queryParamsHandling: 'preserve' },
  { label: 'Add Intent', routerLink: '/configuration/dimensions/subcategory/add-or-edit-intent', queryParamsHandling: 'preserve' }
];

const WISEFLOW_BREADCRUMB: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Wise Flow', routerLink: '/configuration/wiseflow/flow',queryParamsHandling:'preserve' },
  { label: 'Flow', routerLink: '' }
];

const BREADCRUMB_DATA_COMPLIANCE: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Compliance',routerLink: '/configuration/knowledgebase/compliance'},
]


const BREADCRUMB_DATA_ENTITIES: MenuItem[] = [
  { label: 'Home', routerLink: '/home' },
  { label: 'Applications', routerLink: '/home/app' },
  { label: 'Entities' },

]
export const BreadCrumsConstant: { [key: string]: MenuItem[] } = {
  app: BREADCRUMB_DATA_APPLICATIONS,
  dimensions: BREADCRUMB_DATA_DIMENSIONS,
  knowledgebase: BREADCRUMB_DATA_KNOWLEDGEBASE,
  productDetails: BREADCRUMB_DATA_PRODUCT,
  'sme-dashboard': BREADCRUMB_DATA_SME,
  chat: BREADCRUMB_DATA_CHAT,
  prompts: BREADCRUMB_DATA_PROMPTS,
  llm: BREADCRUMB_DATA_LLM,
  tools: BREADCRUMB_DATA_TOOLS,
  events: BREADCRUMB_DATA_EVENTS,
  editinactivity: BREADCRUMB_DATA_EDIT_EVENTS,
  agents: BREADCRUMB_DATA_AGENTS,
  customer: BREADCRUMB_DATA_ORGANIZATIONS,
  roles: BREADCRUMB_DATA_ROLES,
  users: BREADCRUMB_DATA_USERS,
  applications: BREADCRUMB_DATA_APPLICATION,
  email: BREADCRUMB_DATA_EMAIL,
  flow: BREADCRUMB_DATA_WISEFLOW,
  home: BREADCRUMB_DATA_HOME,
  Dashboardemail: BREADCRUMB_DATA_DASHBOARDEMAIL,
  Dashboardchat: BREADCRUMB_DATA_DASHBOARDCHAT,
  customers: BREADCRUMB_DATA_CUSTOMERS,
  settings: BREADCRUMB_DATA_SETTINGS,
  subcategory: BREADCRUMB_DATA_DIMENSIONS_SUBCATEGORY,
  allowed: BREADCRUMB_DATA_ALLOWED,
  addCustomer: BREADCRUMB_DATA_ORGANIZATION,
  config: BREADCRUMB_DATA_CONFIG,
  userconfig: BREADCRUMB_DATA_USERS_CONFIG,
  details: BREADCRUMB_DATA_CUSTOMERTIER,
  intent: BREADCRUMB_DATA_USERS_INTENT,
  errorDetails: BREADCRUMB_DATA_ERRORDETAILS,
  transcriptionError: BREADCRUMB_DATA_TRANSCRIPTIONERROR,
  errorPage: BREADCRUMB_DATA_ERRORPAGE,
  phone: BREADCRUMB_DATA_DASHBOARD_PHONE,
  dashboard: BREADCRUMB_DATA_DASHBOARD_HOME,
  wiseflowtools: BREADCRUMB_DATA_WISEFLOW_TOOLS,
  Channelchat: BREADCRUMB_DATA_CHATS,
  assignResource: BREADCRUMB_DATA_ASSIGNRESOURCE,
  userProfile: BREADCRUMB_DATA_USERS_PROFILE,
  'add-or-edit-intent': BREADCRUMB_DATA_ADD_INTENT,
  Compliance: BREADCRUMB_DATA_COMPLIANCE,
  entities: BREADCRUMB_DATA_ENTITIES,
  'add-prompts':BREADCRUMB_DATA_PROMPTS,
  wiseflow:WISEFLOW_BREADCRUMB,
  'add-tool':BREADCRUMB_DATA_AddTOOLS,
  'api': BREADCRUMB_DATA_API,
  'authentication': BREADCRUMB_DATA_AUTHENTICATION_API
}